import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PropertyComparisonHub from './pages/property-comparison-hub';
import InvestmentROIDashboard from './pages/investment-roi-dashboard';
import MarketTrendsAnalytics from './pages/market-trends-analytics';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<InvestmentROIDashboard />} />
        <Route path="/property-comparison-hub" element={<PropertyComparisonHub />} />
        <Route path="/investment-roi-dashboard" element={<InvestmentROIDashboard />} />
        <Route path="/market-trends-analytics" element={<MarketTrendsAnalytics />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
